export function getPrivateCoachingData() {
  if (process.env.NODE_ENV === 'development') {
    return import('../mock/privateCoachingData').then((module) => {
      return module.mockData();
    });
  }

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/pages/PrivateCoaching`,
    {
      method: 'GET',
    }
  ).then((res) => res.json());
}
